"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteType = void 0;
var NoteType;
(function (NoteType) {
    NoteType["Blank"] = "0";
    NoteType["Don"] = "1";
    NoteType["Ka"] = "2";
    NoteType["DON"] = "3";
    NoteType["KA"] = "4";
    NoteType["Drumroll"] = "5";
    NoteType["DRUMROLL"] = "6";
    NoteType["Balloon"] = "7";
    NoteType["DrumrollEnd"] = "8";
    NoteType["Kusudama"] = "9";
    NoteType["MultiDon"] = "A";
    NoteType["MultiKa"] = "B";
    NoteType["ADLIB"] = "F";
    NoteType["MeasureEnd"] = ",";
})(NoteType = exports.NoteType || (exports.NoteType = {}));
